export default {
  policyNumber: '',
  zipCode: '',
  policyDetails: {
    policyNumber: '',
    balanceSummary: {
      currentInstallment: {
        balanceDue: undefined,
        dueDate: ''
      },
      remainingBalance: undefined
    },
    abbreviatedAddress: {
      street: '',
      zip: ''
    },
    agency: {
      name: ''
    }
  },
  payment: {
    amount: {
      type: '',
      value: ''
    },
    type: 'Card',
    cardInfo: {
      name: '',
      number: '',
      expirationMonth: '',
      expirationYear: '',
      cvv: '',
      expiration: ''
    },
    bankInfo: {
      accountType: 'Checking',
      holderName: '',
      bankName: '',
      routing: '',
      accountNumber: ''
    },
    billingInfo: {
      state: '',
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      zip: ''
    }
  },
  redirect: undefined,
  error: undefined,
  maintenanceMode: false,
  paymentResource: {
    id: '',
    state: '',
    policyNumber: '',
    gateway: {
      name: '',
      token: '',
      paymentUrl: '',
      method: '',
      transactionType: '',
      transactionId: '',
      acceptedCards: []
    },
    paymentDetails: {
      amount: '',
      paymentType: '',
      achPaymentSource: {},
      ccPaymentSource: {}
    }
  },
  returnUrl: `${window.location.origin}/processing-payment`,
  tooltips: {
    expanded: {
      isActive: false,
      key: '',
      containerPosition: undefined,
      scrollDelta: 0
    }
  },
  insuranceType: undefined,
  testMode: undefined
}



// WEBPACK FOOTER //
// ./src/store/initialState.js